import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const buildScrollKey = (pathname: string, search: string) => `${pathname}\n${search}`;

export const ScrollToTopOnRouteChange = () => {
  const { pathname, search } = useLocation();
  const previousKeyRef = useRef(buildScrollKey(pathname, search));

  useEffect(() => {
    const nextKey = buildScrollKey(pathname, search);
    if (previousKeyRef.current === nextKey) {
      return;
    }

    previousKeyRef.current = nextKey;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, search]);

  return null;
};
